const thoughtworksSnippets = require('./20220122_thought_works_snippets/data.js')
const roll2death = require('./20230227_roll_to_death/data.js')
const criticalThinking = require('./20230608_critical_thinking/data.js')

let list = [
  criticalThinking,
  roll2death,
  {
    title: '',
    author: 'zhongbro',
    post: '2023-01-04 20:26',
    summary: [
      '网站备案每年会检查实际站点与备案信息是否一致',
      '今年发现站点名称与登记不符，需要整改',
      '特意更新一次',
      '',
      '立一个flag：下次更新一些有用的东西~🙉'
    ]
  },
  thoughtworksSnippets,
  {
    title: '',
    author: 'zhongbro',
    post: '2021-09-16 15:09',
    summary: [
      '年初部署了Coding的CI/CD流程，这次修正网站的备案链接让部署工作变得十分简单',
      '找到源代码、修改前端工程、测试、提交、自动集成',
      '不过这次比较懒，直接在master分支上面提交了，越过了测试这一步…',
      '',
      '这个方案的风险点可能是忘记自己的Coding账号😂'
    ]
  }, {
    title: '',
    author: 'zhongbro',
    post: '2021-01-14 15:23',
    summary: [
      '这个方法发表一个想法，还是比较繁琐的，但也正因为这种繁琐，让每一条想法都不那么口水。',
      '毕竟能够忍耐冗长流程，通过拉取、修改、编译、打包、部署这些步骤后才能放到互联网上的内容，一定是有强烈想法的。',
      '',
      '目前先做成这样子的静态网站吧'
    ]
  }, {
    title: '为什么VSCode会报错',
    author: 'zhongbro',
    post: '2021-01-14 12:33',
    summary: 'CSS variables have access to the DOM, which means that you can create variables with local or global scope, change the variables with JavaScript, and change the variables based on media queries. A good way to use CSS variables is when it comes to the colors of your design.',
    tags: ['博客', '随心', 'Golang', '分析'],
    md: require('!raw-loader!./1_readme.md').default,
  }, {
    title: '使用CSS自定义属性',
    author: 'gzshi',
    post: '2021-01-14 12:33',
    summary: '自定义属性（有时候也被称作CSS变量或者级联变量）是由CSS作者定义的，它包含的值可以在整个文档中重复使用。由自定义属性标记设定值（比如： --main-color: black;），由var() 函数来获取值（比如： color: var(--main-color);）复杂的网站都会有大量的CSS代码，通常也会有许多重复的值。举个例子，同样一个颜色值可能在成千上百个地方被使用到，如果这个值发生了变化，需要全局搜索并且一个一个替换（很麻烦哎～）。自定义属性在某个地方存储一个值，然后在其他许多地方引用它。另一个好处是语义化的标识。比如，--main-text-color 会比 #00ff00 更易理解，尤其是这个颜色值在其他上下文中也被使用到。',
    tags: ['博客', '随心', 'Golang', '分析'],
    md: require('!raw-loader!./2_where.md').default,
  }]

module.exports = list


// WEBPACK FOOTER //
// ./src/blog/index.js